<app-navbar></app-navbar>

<main class="app-main">
  <router-outlet></router-outlet>
</main>
